module.exports = __webpack_public_path__ + "static/media/bg_05.b4696123.png";